<!-- <app-navbar></app-navbar>
<router-outlet></router-outlet> -->

<!-- <app-navbar></app-navbar> -->

<!-- <app-navbar *ngIf="isAuthenticated"></app-navbar>  -->
<router-outlet></router-outlet>